var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"length":_vm.page.length,"total-visible":7},model:{value:(_vm.page.page),callback:function ($$v) {_vm.$set(_vm.page, "page", $$v)},expression:"page.page"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }